import { render, staticRenderFns } from "./withdrawalOrders.vue?vue&type=template&id=7a6fba50&"
import script from "./withdrawalOrders.vue?vue&type=script&lang=js&"
export * from "./withdrawalOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports